import React, { useState } from "react";
import { useDispatch } from "react-redux";
import DropdownComponet from "./modal/Dropdown";
import { Button, Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import HoverVideoPlayer from "react-hover-video-player";
import { Link, useNavigate } from "react-router-dom";
import { getWidgetWallData } from "../../../../../actions/wallDataAction";
import { toggleAddFeedsSection_D, togglePublishSection_D } from "../../../../../actions/showDisplayModalAction";
import { baseUrl, getInitialRoute, kFormatter } from "../../../../../utils"; 
import { getWallFeeds } from "../../../../../actions/analyticsAction";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";

function WallCards(props) {
  const { name, status, id, themeId, feedCount, themeName, themeLayout, postCount, collaboratorId, collaboratorRole, activeScreen } = props.wallsData;

  const userData = props.userData;
  const { user } = userData;
  const [wallactiveStatus, setwallactiveStatus] = useState(status);
   const dispatch = useDispatch();
  const navigate = useNavigate();

  let collaboratorRole_3 = collaboratorId == user.ownerId ? collaboratorRole === 3 ? false : true : true;

  const displayWindowOpen = (wallId, themeId) => {
    var c_name = 'wallAction';
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + 30);
    var c_value = escape('display') + ((30 == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = c_name + "=" + c_value + ";path=/";
    dispatch(getWidgetWallData(user.ownerId, wallId));
    dispatch(getWallFeeds(user.ownerId));
    const product = getInitialRoute();
    if(product == 'display'){
        dispatch(togglePublishSection_D(true));
        setTimeout(() => navigate(`/display/wall/index/${wallId}`), 1000);
      }else{
        navigate(`/wall/preview/${wallId}`);
    }
  }
 
  return (
    props && props.wallsData && <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-3">
        <div className={`card card-custom card-stretch wall_card ${props && props.wallsData && wallactiveStatus ? `active_wall` : `inactive_wall`} `} style={{ borderBottom : !wallactiveStatus ? '5px solid #ffa5a5' : null }}>        <div className="wall_cont_wrap p-4 innter_wall_cont_wrap_ cursor-pointer">
          <Link to={`/wall/index/${id}`} className="card card-custom overlay shadow-none overflow-hidden rounded-0" onClick={() => { if (feedCount === 0 && collaboratorRole_3) { dispatch(toggleAddFeedsSection_D(true)) } dispatch(getWidgetWallData(localStorage.getItem('ownerId'), id)) }}>
            <HoverVideoPlayer
              videoSrc={`${baseUrl(`theme-media/theme-video/${themeId}.mp4`)}`}
              pausedOverlay={<img className="img-fluid h-100 object-fit-cover" src={`${baseUrl(`theme-media/theme-thumb/${themeId}.png`)}`}
                alt={name} width={391} height={218} />}
              width={391} height={218}
              style={{
                width: '100%',
                paddingTop: '55%',
              }}
            />
            <div className="overlay-layer">
              <FontAwesomeIcon type={'solid'} icon={'circle-play'} iconClass={'fs-1 rounded-circle bg-white'} />
            </div>
          </Link>

          <div className="row align-items-start justify-content-between wall_head h-auto mb-0 pt-3">
            <div className="col-lg-7 col-md-6 col-sm-12 col-6">
              <div className="card-title">
                <div className="d-flex align-items-center"> 
                  <h5  className="card-label me-2">
                    <Link to={`/wall/index/${id}`} onClick={() => { if (feedCount === 0 && collaboratorRole_3) { dispatch(toggleAddFeedsSection_D(true)) } dispatch(getWidgetWallData(localStorage.getItem('ownerId'), id)) }} style={{ cursor: 'pointer' }} className="wallName whitelabelanchor font-weight-bolder overflow-hidden text-nowrap text-ellipsis">
                      {name}
                    </Link>
                  </h5>
                  { activeScreen ? <span className="status_active"></span> : null }
                </div>
                <p className="mb-0 text-secondary mt-1 text-capitalize">{`${themeName} : ${themeLayout}`} </p>
                  {/* <p className="mb-0 text-secondary mt-1 text-capitalize">Total Posts :  {kFormatter(postCount)}</p> */}
              </div>
            </div>
            <div className="col-lg-5 col-md-6 col-sm-12 col-6">
              <div className="card-toolbar d-flex align-items-center justify-content-end">
                <div className="card-options d-flex align-items-center">
                  <OverlayTrigger placement="top" overlay={<Tooltip>{"Display"}</Tooltip>}>
                    <Button variant="link" className="p-2" onClick={() => { navigate(`/wall/preview/${id}`); displayWindowOpen(id, themeId)}}>
                      <FontAwesomeIcon type={'solid'} icon={'display'} iconClass={'text-secondary'} />
                    </Button>
                  </OverlayTrigger>
                  <OverlayTrigger placement="top" overlay={<Tooltip>{"Moderation"}</Tooltip>}>
                    <Button variant="link" className="p-2" onClick={() => { navigate(`/moderation/index/${id}`); localStorage.setItem('wallId',id) }}> 
                      <FontAwesomeIcon type={'solid'} icon={'check-to-slot'} iconClass={'text-secondary'} />
                    </Button>
                  </OverlayTrigger>
                  <OverlayTrigger placement="top" overlay={<Tooltip>{"Analytics"}</Tooltip>}>
                    <Link to={`${![58].includes(userData.UserPlan.planId) ? '/analytic/' : 'analytic/'}${id}`} className="p-2 btn btn-link" onClick={() => dispatch(getWidgetWallData(localStorage.getItem('ownerId'), id))}>
                      <FontAwesomeIcon type={'regular'} icon={'chart-simple'} iconClass={'text-secondary'} />
                    </Link>
                  </OverlayTrigger>
                  <OverlayTrigger placement="top" overlay={<Tooltip>{"Edit"}</Tooltip>}>
                    <Link to={`/wall/index/${id}`} className="p-2 btn btn-link" onClick={() => { if (feedCount === 0 && collaboratorRole_3) { dispatch(toggleAddFeedsSection_D(true)) } dispatch(getWidgetWallData(user.ownerId, id)) }}>
                      <FontAwesomeIcon type={'regular'} icon={'pen-to-square'} iconClass={'text-secondary'} />
                    </Link>
                  </OverlayTrigger>
                  
                  
                  
                </div>
                <Dropdown align={'end'}>
                  <Dropdown.Toggle variant="link" className="p-2">
                    <span><FontAwesomeIcon type={'regular'} icon={'ellipsis-vertical'} iconClass={'text-secondary'} /></span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu style={{ width: 175 }}>
                    <DropdownComponet setwallactiveStatus={setwallactiveStatus} props={props} ownerId={user.ownerId} userData={userData}/>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WallCards;